export default {"src":"/_next/static/media/notecard-solutions.0e08a98c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};